import { FC } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import Checkbox from 'components/forms/Checkbox';
import UploadExemption, { UploadExemptionFieldType } from 'components/forms/UploadExemption';
import { printf } from 'utils/i18n';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

export interface ExemptionFormutilType extends UploadExemptionFieldType {
    temporary_check_other_broker_proof: boolean;
}

const Exemption: FC<ProgressFormProps<ExemptionFormutilType>> = ({ onSubmit }) => {
    const handleSubmit = (ev: React.FormEvent) => {
        onSubmit('../job', ev);
    };

    return (
        <form className="exemption-root" noValidate onSubmit={handleSubmit}>
            <h3 className="open-title my-4">{printf(__('上传%s'), __('开户补充文件')).toUpperCase()}</h3>
            <UploadExemption />
            <BackNextButtons sticky>
                <Checkbox
                    className="mb-1"
                    name="temporary_check_other_broker_proof"
                    checker={value => value || __('请勾选承诺内容')}
                    label={__('我承诺我在其他境外券商账户开通时间在2023年5月19日前')}
                />
            </BackNextButtons>
        </form>
    );
};

export default withProgressForm({
    id: 'exemption',
    basePath: 'open',
    step: 2,
    eventParams: {
        exposureEventParams: {
            model: '开户-其他券商证明',
            name: '其他券商证明-页面曝光'
        },
        submitEventParams: {
            model: '开户-其他券商证明',
            name: '其他券商证明-点击下一步'
        }
    }
})(Exemption);
